import scopeLogger from 'lib/scope-logger.js';

const console = scopeLogger('RMI:get-element-rect');
/**
 *
 * @param {Element} element
 * @return {Promise<DOMRectReadOnly>}
 */
export function getElementRect(element) {
  console.log('request element rect for', element.innerText || element.role);
  return new Promise((resolve) => {
    const emergencyTimeout = setTimeout(() => {
      console.log('fake resolve rect for', element.innerText || element.role);
      observer.disconnect();
      resolve({
        x: Infinity,
        y: Infinity,
        width: 0,
        height: 0,
        top: Infinity,
        right: Infinity,
        bottom: Infinity,
        left: Infinity,
      });
    }, 120);
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        console.log('resolve rect for', element.innerText || element.role);
        clearTimeout(emergencyTimeout);
        resolve(entry.boundingClientRect);
      }

      observer.disconnect();
    });

    observer.observe(element);
  });
}

/**
 * Returns a Promise that resolves with the rectangle information of a given element.
 * Instead of v1 this function returns a Promise that resolves with an IntersectionObserverEntry object.
 * Instead of v1 this function rejects with an Error object in case of timeout.
 *
 * @todo Find all usage of v1 and replace with v2.
 *     It's not possible to use v2 in all cases because of different returned value.
 *
 * @param {Element} element - The element to retrieve the rectangle information from.
 * @param {Object} options - The options to be passed to the IntersectionObserver constructor.
 * @return {Promise<Object>} - A Promise that resolves with the rectangle information of the element.
 */
export function getElementRectV2(element, options) {
  return new Promise((resolve, reject) => {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        console.log('resolve rect for', element.id || element.role);
        clearTimeout(emergencyTimeout);
        resolve(entry);
      }

      observer.disconnect();
    }, options);
    const emergencyTimeout = setTimeout(() => {
      observer.disconnect();
      const error = new Error('Timeout: getting element rect');
      reject(error);
    }, 120);

    observer.observe(element);
    console.log('request element rect for', element.innerText || element.role);
  });
}
